module.exports = __webpack_public_path__ + "static/media/hs-with-hostastay-bg.a0e10960.png";